import { useCallback } from 'react';
import type { Task } from '@/api/types';
import { useI18n } from '@/i18n/useI18n';

/**
 * The words on a step: what the studio authored for this slot (the server has already resolved it for
 * the session's language), else the room's own string. One lookup, so no component can drift.
 */
export function useTaskText(task: Task) {
  const { t } = useI18n();
  const authored = task.ui?.text;
  return useCallback(
    (slot: string, key: string, vars?: Record<string, string | number>): string =>
      authored?.[slot] ?? t(key, vars),
    [authored, t],
  );
}
